import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { addPurchase } from 'Services/purchases/purchasesService'
import { usePeoplePageContext } from 'Contexts/PeoplePageContext'

export const useAddPurchaseForUserMutation = () => {
  const { setModal } = usePeoplePageContext()
  const queryClient = useQueryClient()

  return useMutation([QueryNames.AddPurchaseForUser], addPurchase, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.GetUserPurchases])
        queryClient.invalidateQueries([QueryNames.GetUserOngoingPurchases])
        queryClient.invalidateQueries([QueryNames.GetUserPendingOPRPurchases])
        queryClient.invalidateQueries([QueryNames.GetReportedPurchases])
        toast.success(AppNotification.AddPurchaseForUserSuccess)
        setModal(undefined)
      } else {
        toast.error(`${AppNotification.AddPurchaseForUserFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.AddPurchaseForUserFailure)
    }
  })
}
